var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "new-sales-note",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("VoucherDetails", {
              ref: "voucherDetailsComponent",
              attrs: { "is-loading": _vm.isLoading, inline: true }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [_c("Concepts", { attrs: { "is-loading": _vm.isLoading } })],
          1
        ),
        _c("div", { staticClass: "column is-12 action-buttons" }, [
          _c("div", { staticClass: "field is-grouped" }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-success",
                  class: { "is-loading": _vm.isLoading },
                  attrs: { type: "submit", disabled: _vm.isLoading },
                  on: {
                    click: function($event) {
                      return _vm.setSaleNote(true)
                    }
                  }
                },
                [_vm._v("\n            Crear Nota de Remisión\n          ")]
              )
            ]),
            _c(
              "p",
              { staticClass: "control" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass: "button is-danger",
                    class: { "is-loading": _vm.isLoading },
                    attrs: { disabled: _vm.isLoading, to: { name: "Home" } }
                  },
                  [_vm._v("\n            Cancelar\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c("RouterView")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }